import React, { useState } from 'react';

const SlideOutNav = ({ currentPage, onNavigate }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleNav = () => {
    setIsOpen(!isOpen);
  };

  const handleNavigate = (page) => {
    onNavigate(page);
    setIsOpen(false);
  };

  const navItems = [
    {
      id: 'landing',
      label: 'Home',
      icon: '🏠',
      description: 'RateLens Overview'
    },
    {
      id: 'simulator',
      label: 'Rate Simulator',
      icon: '🎯',
      description: 'Interactive Rate Modeling'
    },
    {
      id: 'marketdata',
      label: 'Live Market Data',
      icon: '📡',
      description: 'Real-time Economic Indicators'
    },
    {
      id: 'howitworks',
      label: 'How It Works',
      icon: '🎓',
      description: 'Understanding Rate Drivers'
    },
    {
      id: 'governmentloans',
      label: 'Government Loans',
      icon: '🏛️',
      description: 'FHA, VA, USDA Programs'
    },
    {
      id: 'armrates',
      label: 'ARM Rates',
      icon: '📊',
      description: 'Adjustable Rate Mortgages'
    },
    {
      id: 'helocrates',
      label: 'HELOC & Equity',
      icon: '🏠',
      description: 'Home Equity Credit Lines'
    },
    {
      id: 'loanqualification',
      label: 'AI Qualification',
      icon: '🤖',
      description: 'AI-Powered Loan Analysis'
    }
  ];

  return (
    <>
      {/* Navigation Button */}
      <button
        onClick={toggleNav}
        className={`fixed top-4 right-4 z-50 p-3 bg-blue-600 text-white rounded-full shadow-lg hover:bg-blue-700 transition-all duration-200 ${
          isOpen ? 'rotate-45' : ''
        }`}
        aria-label="Open navigation menu"
      >
        <svg 
          className="w-6 h-6" 
          fill="none" 
          stroke="currentColor" 
          viewBox="0 0 24 24"
        >
          <path 
            strokeLinecap="round" 
            strokeLinejoin="round" 
            strokeWidth={2} 
            d={isOpen ? "M12 6v6m0 0v6m0-6h6m-6 0H6" : "M4 6h16M4 12h16M4 18h16"} 
          />
        </svg>
      </button>

      {/* Overlay */}
      {isOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-40 transition-opacity duration-200"
          onClick={() => setIsOpen(false)}
        />
      )}

      {/* Slide-out Panel */}
      <div
        className={`fixed top-0 right-0 h-full bg-white shadow-2xl z-50 transform transition-transform duration-300 ease-in-out ${
          isOpen ? 'translate-x-0' : 'translate-x-full'
        } w-80 flex flex-col`}
      >
        {/* Header - Fixed */}
        <div className="flex-shrink-0 p-6 border-b border-gray-200">
          <div className="flex items-center justify-between">
            <div>
              <h2 className="text-2xl font-bold text-gray-900">RateLens</h2>
              <p className="text-sm text-gray-600">Navigation</p>
            </div>
            <button
              onClick={() => setIsOpen(false)}
              className="p-2 text-gray-500 hover:text-gray-700 hover:bg-gray-100 rounded-full"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
        </div>

        {/* Scrollable Content */}
        <div className="flex-1 overflow-y-auto p-6">
          {/* Navigation Items */}
          <nav className="space-y-4">
            {navItems.map((item) => (
              <button
                key={item.id}
                onClick={() => handleNavigate(item.id)}
                className={`w-full text-left p-4 rounded-lg transition-all duration-200 ${
                  currentPage === item.id
                    ? 'bg-blue-50 border-2 border-blue-200 text-blue-900'
                    : 'bg-gray-50 hover:bg-gray-100 border-2 border-transparent text-gray-700 hover:text-gray-900'
                }`}
              >
                <div className="flex items-center space-x-4">
                  <span className="text-2xl">{item.icon}</span>
                  <div>
                    <h3 className="font-semibold">{item.label}</h3>
                    <p className="text-sm opacity-75">{item.description}</p>
                  </div>
                </div>
                {currentPage === item.id && (
                  <div className="mt-2 text-xs bg-blue-100 text-blue-700 px-2 py-1 rounded inline-block">
                    Current Page
                  </div>
                )}
              </button>
            ))}
          </nav>

          {/* Footer */}
          <div className="mt-8 pt-6 border-t border-gray-200">
            <div className="text-center">
              <p className="text-xs text-gray-500">
                RateLens v1.0 - Mortgage Rate Intelligence
              </p>
              <div className="flex justify-center space-x-4 mt-3">
                <span className="text-xs bg-green-100 text-green-700 px-2 py-1 rounded">
                  🟢 Live Data
                </span>
                <span className="text-xs bg-blue-100 text-blue-700 px-2 py-1 rounded">
                  🤖 AI Powered
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SlideOutNav;
